export enum IncidentOriginEnum {
  MANUAL = 'MANUAL',
  AUTOMATIC = 'AUTOMATIC'
}
